import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f43c023"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-4 mx-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_AddQualification = _resolveComponent("AddQualification", true)!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["add-qualification bg-background", { invisible: _ctx.isCameraActive }])
  }, [
    _createVNode(_component_Header, null, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      新しい資格を追加\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_CustomValidationObserver, null, {
        default: _withCtx(({ handleSubmit }) => [
          _createVNode(_component_AddQualification, {
            modelValue: _ctx.inputValues,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputValues) = $event)),
            qualificationOptions: _ctx.filteredQualificationOptions,
            isCameraActive: _ctx.isCameraActive,
            "onUpdate:isCameraActive": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isCameraActive) = $event))
          }, null, 8, ["modelValue", "qualificationOptions", "isCameraActive"]),
          _createTextVNode(),
          _createVNode(_component_AppButton, {
            block: "",
            class: "mt-4",
            disabled: _ctx.isSubmitting,
            onClick: ($event: any) => (handleSubmit(_ctx.onClickSubmit))
          }, {
            default: _withCtx(() => [
              _createTextVNode("\n          追加する\n        ")
            ], undefined, true),
            _: 2
          }, 1032, ["disabled", "onClick"])
        ]),
        _: 1
      })
    ])
  ], 2))
}